<template>
    <div role="tabpanel" :id="'wizard-' + index" :data-page-index="index" :data-page-stepid="stepid" class="wizard-page tab-pane" :class="[ active ? 'active' : '' ]">
        <div class="panel-body pt-4">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
  name: 'FormWizardStep',
  props: { 
    index: {
      type: String,
      default: ''
    },
    stepid: {
      type: String,
      default: ''
    },
    active: Boolean
  }
}
</script>